/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import ButtonList from 'app/components/common/ButtonList.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import SocialConfigButtons from 'app/mixins/SocialConfigButtons.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import Toggle from 'app/components/common/ToggleControl.jsx';
import SocialButton from 'app/components/common/SocialButton.jsx';
import SocialEditorPanel from 'app/components/EditorComponents/SocialPanels/SocialEditorPanel.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import * as _ from 'underscore';
import classnames from 'classnames';
import Loading from 'app/components/common/Loading.jsx';
import Utilities from 'app/utility/Utilities.js';

const getOutput = (props) => {
    for (let i = 0; i < props.automatedRoutes.list.length; ++i) {
        for (let j = 0; j < props.automatedRoutes.list[i].outputs.length; ++j) {
            if (parseInt(props.automatedRoutes.list[i].outputs[j].id, 10) === parseInt(props.outputID, 10)) {
                return props.automatedRoutes.list[i].outputs[j];
            }
        }
    }
    return null;
};

class OutputConfigModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            output: {},
            social: {},
            socialDefaults: null,
            activePanel: 'options',
            errors: null,
            deleteConfirmation: false,
            isDirty: false
        };

        this.deleteOutput = this.deleteOutput.bind(this);
        this.toggleDefaultUsage = this.toggleDefaultUsage.bind(this);
        this.saveOutput = this.saveOutput.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.setActivePanel = this.setActivePanel.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {};

        // update social in state when details come back
        if (props.socials.list.length) {
            for (let i = 0; i < props.socials.list.length; ++i) {
                if (parseInt(props.socials.list[i].id, 10) === parseInt(props.socialID, 10) && props.socials.list[i].params !== undefined) {
                    nextState.social = Utilities.deepClone(props.socials.list[i]);
                    break;
                }
            }
        }

        if (props.automatedRoutes.list.length) {
            if (_.isEmpty(state.output)) {
                let output = getOutput(props);
                if (output && output.paParams !== undefined) {
                    nextState.output = output;
                }
            }
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

        this.props.getOutput(this.props.outputID);
        this.props.getSocial(this.props.socialID);
        this.props.deleteApiError(['OUTPUT_DELETE', 'OUTPUT_UPDATE', 'SOCIAL_UPDATE']);

    }

    componentDidUpdate(prevProps, prevState) {

        let errors = [];

        errors = this.props.getApiErrors(['OUTPUT_DELETE', 'OUTPUT_UPDATE', 'SOCIAL_UPDATE']);

        if (errors.length && this.state.errors === null) {
            if (this.props.getPermErrors().length) {
                this.props.showUpgradeModal(this.props.closeAllModals, null, errors, 'social_error');
            }
            this.setState({
                errors
            });
        }

        if (((prevProps.app.loading.OUTPUT_UPDATE === true && this.props.app.loading.OUTPUT_UPDATE === false) ||
            (prevProps.app.loading.OUTPUT_DELETE === true && this.props.app.loading.OUTPUT_DELETE === false)) &&
            errors.length === 0) {
            this.props.closeAllModals();
        }

    }

    deleteOutput(e) {
        let deleteConfirmation = this.state.deleteConfirmation;

        e.preventDefault();

        if (deleteConfirmation) {
            deleteConfirmation = false;
            this.props.deleteOutput(this.state.output.id);
        } else {
            deleteConfirmation = true;
        }

        this.setState({
            deleteConfirmation
        });

    }

    toggleDefaultUsage(e) {
        let nextState = e.currentTarget.dataset.togglestate === 'true' ? false : true,
            output = this.state.output;

        if (!nextState) {
            return;
        }

        output.paParams = null;

        this.setState({
            output: output,
            isDirty: true
        });
    }

    saveOutput(e) {
        e.preventDefault();

        let output = getOutput(this.props);

        if (parseInt(output.activeFlag, 10) === 0 &&
            parseInt(this.state.output.activeFlag, 10) === 1 &&
            parseInt(this.state.social.activeFlag, 10) === 0) {
            let social = Utilities.deepClone(this.state.social);
            social.activeFlag = 1;
            this.props.updateSocial(social);
        }

        // clear out any previous errors
        this.props.deleteApiError(['OUTPUT_CREATE', 'OUTPUT_UPDATE']);

        // update
        this.props.updateOutput(this.state.output);

    }

    changeHandler(e) {
        let output = this.state.output,
            savedEvent = {
                currentTarget: null,
                target: null
            },
            savedTarget = null;

        savedEvent.target = {
            value: _.clone(e.target.value)
        };
        savedEvent.currentTarget = {
            dataset: _.clone(e.currentTarget.dataset)
        };

        // if paParams is null, the user is changing a default
        // value to use an override. clone the social params
        if (output.paParams === null) {
            output.paParams = Utilities.deepClone(this.state.social.params);
            this.setState({
                output: output,
                isDirty: true
            }, () => {
                FormUtilityMixin.requestChange.apply(this, [savedEvent]);
            });
        } else {
            this.setState({
                isDirty: true
            }, () => {
                FormUtilityMixin.requestChange.apply(this, [savedEvent]);
            });
        }

    }

    setActivePanel(e) {
        let activePanel = e.currentTarget.dataset.panel;

        if (activePanel) {
            this.setState({
                activePanel
            });
        }
    }

    render() {
        let modalTitle = null,
            modalContainer = null,
            footerContent = null,
            errorBlock = null,
            buttons = null,
            deleteAction = this.deleteOutput,
            isActive = this.state.output.paParams === null ? true : false,
            Icon = null,
            ServiceIcon = null,
            service = null,
            avatar = null,
            saveClasses = null,
            { children, ...otherProps } = this.props;

        buttons = SocialConfigButtons.getButtons.apply(this, [this.setActivePanel, this.state.activePanel]);

        if (this.state.social.name) {
            modalTitle = <span>Settings for {this.state.social.name}</span>;
        }

        if (this.props.type) {
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.type)];
        }

        if (this.state.social.psID) {
            ServiceIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.state.social.psID)];
            if (ServiceIcon) {
                service = <ServiceIcon border={true}/>;
            }
        }

        if (this.state.social.icon) {
            avatar = <div className="avatar-bg"><img src={this.state.social.icon} className="avatar-img"/></div>;
        } else {
            avatar = <div className="avatar-bg"><i className="fa fa-user"></i></div>;
        }

        // decorate the props to pass to children
        otherProps.output = this.state.output;
        otherProps.social = this.state.social;
        otherProps.changeHandler = this.changeHandler;
        otherProps.activePanel = this.state.activePanel;
        otherProps.deleteHandler = deleteAction;
        otherProps.deleteConfirmation = this.state.deleteConfirmation;
        otherProps.fieldMapping = "output.paParams";
        otherProps.errorMapping = "paParams";
        otherProps.errors = this.state.errors;

        modalContainer = (
            <div>
                <div className="output-modal-panels">
                    <div className="output-modal-icon">
                        <div className="output-service-icon">
                            {service}
                        </div>
                        <div className="social-avatar large relative">
                            {avatar}
                        </div>
                    </div>
                    <div className="output-modal-panel">
                        {errorBlock}
                        <ButtonList
                            buttons={buttons}
                            wrapperClass="editor-tabs"
                            linkClass="editor-tab-item"
                            activeClass="tab-active"
                            errorClass="tab-error" />
                        <div className="output-defaults">
                            <div className="route-reference">
                                <div className="ref-table">
                                    <div className="icon-cell">
                                        <Icon />
                                    </div>
                                    <div className="name-cell">
                                        {this.props.name}
                                    </div>
                                </div>
                            </div>
                            <div className="default-toggle">
                                <Toggle
                                    active={isActive}
                                    activeLabel="Using Global Settings"
                                    inactiveLabel="Reset to Global Settings"
                                    callback={this.toggleDefaultUsage}
                                    labelClass="output-defaults-label" />
                            </div>
                        </div>
                        <SocialEditorPanel
                            {...otherProps} />
                    </div>
                </div>
            </div>
        );

        saveClasses = classnames(
            'btn-primary',
            'fixed',
            'save-button',
            {
                'active': this.state.isDirty
            }
        );

        footerContent = (
            <div className="editor-buttons">
                <div className="cancel-button" onClick={this.props.closeAllModals} role="button" aria-label="cancel edit">cancel</div>
                <button className={saveClasses} onClick={this.saveOutput}>save</button>
            </div>
        );

        if (this.props.app.loading.output || this.props.app.loading.social) {
            modalContent = (
                <Loading/>
            );
        }

        return (
            <Modal
                headerContent={modalTitle}
				menuContent={null}
				content={modalContainer}
				close={this.props.closeAllModals}
                footerContent={footerContent} />
        );
    }

};

OutputConfigModal.displayName = "OutputConfigModal";

OutputConfigModal.propTypes = {
    name: PropTypes.string,
    type: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    recordPath: PropTypes.func,
};

OutputConfigModal.defaultProps = {
    name: '',
    type: '',
    recordPath: null,
};

export default OutputConfigModal;
